<template>
  <div
    :class="[
      'asc-page-plot-wrapper',
      miniPlot ? 'asc-page-plot-wrapper--mini' : null,
    ]"
    data-automation-id="wrapper_page_plot"
  >
    <div
      :class="[
        'asc-page-plot-wrapper--page-plot',
        !miniPlot ? 'asc-page-plot-wrapper--full' : null,
      ]"
    >
      <template v-if="!plotEditor">
        <asc-plot-header-wrapper
          :is-recommendation-tab="isRecommendationTab"
          :page-plot="pagePlot"
          :editable="editable"
          :plots-eyeballs-visible="plotsEyeballsVisible"
          :plots-eyeballs-readonly="plotsEyeballsReadonly"
          :is-plot-updating="isPlotUpdating"
          :on-delete-page-plot="onDeletePagePlot"
          :on-toggle-page-plot-visibility="onTogglePagePlotVisibility"
        ></asc-plot-header-wrapper>
      </template>
      <template v-if="plotEditor">
        <asc-plot-manager-wrapper
          :allow-add-to-issue="allowAddToIssue"
          :is-recommendation-tab="isRecommendationTab"
          :flight-data-attach-plot-to-mx-rec-permission="
            flightDataAttachPlotToMxRecPermission
          "
          :page-plot="pagePlot"
          :mx-rec-plot="mxRecPlot"
          :associating="associating"
          :saving="saving"
          :editable="editable"
          :tabs-invalid="tabsInvalid"
          :action-buttons="actionButtons"
          :is-close-button-visible="isCloseButtonVisible"
          :is-duplicate-button-visible="isDuplicateButtonVisible"
          :is-associate-button-visible="isAssociateButtonVisible"
          :on-duplicate-page-plot="onDuplicatePagePlot"
          :on-add-issue-to-page-plot="onAddIssueToPagePlot"
          :on-close-page-plot="onClosePagePlot"
          :on-save-page-plot="onSavePagePlot"
          :on-apply-page-plot="handleApplyPagePlot"
          :on-apply-invalid-page-plot="handleApplyInvalidPagePlot"
        ></asc-plot-manager-wrapper>
      </template>
      <div :id="getPagePlotHtmlId" class="asc-page-plot-wrapper--image">
        <template v-if="plotEditor">
          <asc-plot-options-wrapper
            :page-plot="pagePlot"
            :chart-data="getCurrentChartData"
            :filter-lookups="filterLookups"
            :readonly="isReadOnly"
            :saving="saving"
            :disabled="disabled"
            :editable="editable"
            :no-data="getNoData"
            :tabs-invalid="tabsInvalid"
            :display-error-message="getDisplayErrorMessage"
            :hide-hidden-tabs="hideHiddenTabs"
            :on-add-tab-to-page-plot="onAddTabToPagePlot"
            :on-remove-tab-from-page-plot="onRemoveTabFromPagePlot"
            :on-update-tab-view-page-plot="onUpdateTabViewPagePlot"
            :on-apply-page-plot="handleApplyPagePlot"
            :on-apply-invalid-page-plot="handleApplyInvalidPagePlot"
            :on-disable-submit="onDisableSubmit"
            :on-change-tab-index="handleChangeTabIndex"
            :is-tab-menu-disabled="isTabMenuDisabled"
          ></asc-plot-options-wrapper>
        </template>
        <div class="asc-page-plot-wrapper--chart">
          <asc-plot-chart-wrapper
            :page-plot="pagePlot"
            :mini-plot="miniPlot"
            :mx-rec-plot="mxRecPlot"
            :reports-plot="reportsPlot"
            :live-chart="liveChart"
            :loading-plot-ids="loadingPlotIds"
            :chart-data="getCurrentChartData"
            :disabled="disabled"
            :no-data="getNoData"
            :on-update-tab-view-page-plot="onUpdateTabViewPagePlot"
            :on-apply-page-plot="handleApplyPagePlot"
            :plot-editor="plotEditor"
            :hide-hidden-tabs="hideHiddenTabs"
          ></asc-plot-chart-wrapper>
          <template v-if="mxRecPlot || reportsPlot">
            <div class="asc-page-plot-wrapper--footer-container">
              <div class="asc-page-plot-wrapper--footer">
                <asc-plot-footer-wrapper
                  :page-plot="pagePlot"
                  :mini-plot="miniPlot"
                  :mx-rec-plot="mxRecPlot"
                  :editable="editable"
                  :on-update-caption="onUpdatePagePlotCaption"
                  :on-expand="onExpand"
                ></asc-plot-footer-wrapper>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PLOT_UPDATE_MESSAGES } from '@/utilities/appConsts'
import { getChartTypeGivenPlotTypeId } from '@/utilities/plotting'
import _ from 'lodash'
import AscPlotChartWrapper from './AscPlotChartWrapper'
import AscPlotFooterWrapper from './AscPlotFooterWrapper'
import AscPlotHeaderWrapper from './AscPlotHeaderWrapper'
import AscPlotManagerWrapper from './AscPlotManagerWrapper'
import AscPlotOptionsWrapper from './AscPlotOptionsWrapper'

export default {
  name: 'AscPagePlotWrapper',

  components: {
    AscPlotHeaderWrapper,
    AscPlotManagerWrapper,
    AscPlotOptionsWrapper,
    AscPlotChartWrapper,
    AscPlotFooterWrapper,
  },

  props: {
    allowAddToIssue: {
      type: Boolean,
      default: false,
    },
    pagePlot: {
      type: Object,
      default: () => {},
    },
    mxRecPlot: {
      type: Boolean,
      default: false,
    },
    reportsPlot: {
      type: Boolean,
      default: false,
    },
    loadingPlotIds: {
      type: Array,
      default: () => [],
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    filterLookups: {
      type: Array,
      default: () => [],
    },
   
    flightDataAttachPlotToMxRecPermission: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    plotEditor: {
      type: Boolean,
      default: false,
    },
    associating: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    miniPlot: {
      type: Boolean,
      default: false,
    },
    liveChart: {
      type: Boolean,
      default: true,
    },
    actionButtons: {
      type: Boolean,
      default: true,
    },
    isCloseButtonVisible: {
      type: Boolean,
      default: true,
    },
    isDuplicateButtonVisible: {
      type: Boolean,
      default: true,
    },
    isAssociateButtonVisible: {
      type: Boolean,
      default: true,
    },
    hideHiddenTabs: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsVisible: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsReadonly: {
      type: Boolean,
      default: false,
    },
    onCreatePagePlot: {
      type: Function,
      default: () => {},
    },
    onDuplicatePagePlot: {
      type: Function,
      default: () => {},
    },
    onAddIssueToPagePlot: {
      type: Function,
      default: () => {},
    },
    onClosePagePlot: {
      type: Function,
      default: () => {},
    },
    onSavePagePlot: {
      type: Function,
      default: () => {},
    },
    onAddTabToPagePlot: {
      type: Function,
      default: () => {},
    },
    onRemoveTabFromPagePlot: {
      type: Function,
      default: () => {},
    },
    onUpdateTabViewPagePlot: {
      type: Function,
      default: () => {},
    },
    onApplyPagePlot: {
      type: Function,
      default: () => {},
    },
    onDisableSubmit: {
      type: Function,
      default: () => {},
    },
    onDeletePagePlot: {
      type: Function,
      default: () => {},
    },
    onTogglePagePlotVisibility: {
      type: Function,
      default: () => {},
    },
    onUpdatePagePlotCaption: {
      type: Function,
      default: () => {},
    },
    onExpand: {
      type: Function,
      default: () => {},
    },
    readonly: {
      type: Boolean,
    },
    isTabMenuDisabled: {
      type: Boolean,
      default: false,
    },
    isRecommendationTab: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentChartData: [],
      displayErrorMessage: false,
      tabsInvalid: false,
    }
  },

  computed: {
    isPlotUpdating() {
      return this.loadingPlotIds.includes(this.pagePlot.id)
    },
    getCurrentChartData() {
      this.updateCurrentChartData()
      return this.currentChartData
    },

    getDisplayErrorMessage() {
      return this.displayErrorMessage && (!this.disabled || !this.isReadOnly)
    },

    getPagePlotHtmlId() {
      return `image-node-${this.pagePlot.id}`
    },

    isReadOnly() {
      if (this.readonly) return this.readonly
      return !this.plotEditor || (this.plotEditor && this.saving)
    },

    getNoData() {
      if (this.getChartType === 'time') {
        return this.isTimeChartsEmpty
      }
      if (this.getChartType === 'box') {
        return this.isBoxChartsEmpty
      }
      return false
    },

    getChartType() {
      return getChartTypeGivenPlotTypeId(this.pagePlot.plotTypeId)
    },

    getGroupedTimeCharts() {
      const items = this.chartData.filter(
        item => item.plotId === this.pagePlot.id,
      )
      const grouped = _.groupBy(items, 'chartIndex')
      const mapped = Object.keys(grouped).map((item, index) => {
        return {
          chartIndex: Number(item),
          data: Object.values(grouped)[index],
        }
      })
      return mapped
    },

    isTimeChartsEmpty() {
      return this.getGroupedTimeCharts.length === 0
    },

    isBoxChartsEmpty() {
      const [first] = this.chartData.filter(
        item => item.plotId === this.pagePlot.id,
      )

      if (first) {
        const data = first.data
        return (
          (data.fleet === null ||
            data.fleets === undefined ||
            data.fleets.length === 0) &&
          (data.tails === undefined || data.tails.length === 0)
        )
      }

      return true
    },
  },

  watch: {
    pagePlot: {
      deep: true,
      handler(newPagePlot) {
        this.pagePlot = newPagePlot
        this.tabsInvalid = this.areTabsInvalid(newPagePlot.options.data.tabs)
      },
    },
  },

  methods: {
    updateCurrentChartData() {
      const filteredChartData = this.chartData.filter(
        item => item.plotId === this.pagePlot.id,
      )
      if (this.currentChartData.length === 0) {
        this.currentChartData = filteredChartData
      } else {
        const length1 = this.currentChartData.length
        const length2 = filteredChartData.length
        if (length1 !== length2) {
          this.currentChartData = filteredChartData
        }

        const maxDate1 = this.currentChartData.reduce((prev, current) => {
          const currentDate = new Date(current.dateUpdated).getTime()
          return prev > currentDate ? prev : currentDate
        }, 0)
        const maxDate2 = filteredChartData.reduce((prev, current) => {
          const currentDate = new Date(current.dateUpdated).getTime()
          return prev > currentDate ? prev : currentDate
        }, 0)
        if (maxDate1 < maxDate2) {
          this.currentChartData = filteredChartData
        }
      }
    },

    handleApplyPagePlot(plotId, plotTypeId, event, options) {
      if (this.onApplyPagePlot) {
        this.onApplyPagePlot(plotId, plotTypeId, event, options)
      }
    },

    handleApplyInvalidPagePlot() {
      this.displayErrorMessage = true
    },

    handleChangeTabIndex(plotId, plotTypeId, tabIndex) {
      this.handleApplyPagePlot(
        plotId,
        plotTypeId,
        PLOT_UPDATE_MESSAGES.updatePlotTabIndex,
        tabIndex,
      )
    },

    areTabsInvalid(tabs) {
      return tabs.filter(tab => this.isTabInvalid(tab)).length > 0
    },

    isTabInvalid(tab) {
      let invalid = false
      tab.selection.forEach(item => {
        if (!invalid && item.selection) {
          if (item.selection.length < item.validationCount) {
            invalid = true
          }
        }
      })
      return invalid
    },
  },
}
</script>

<style lang="scss">
.asc-page-plot-wrapper {
  &--image {
    .asc-tab__content--secondary {
      border-bottom: 1px solid $gray-400;
    }
  }
}

.asc-page-plot-wrapper--full {
  border: 1px solid $gray-400;
  margin-top: 16px;
}

.asc-page-plot-wrapper--mini {
  width: 50%;
  margin-bottom: 32px;

  .asc-no-data--container {
    min-height: 300px;
  }
}

.asc-page-plot-wrapper--mini:nth-child(even) {
  padding-left: 16px;
}

.asc-page-plot-wrapper-mini:nth-child(n + 3) {
  margin-top: 16px;
}

.asc-page-plot-wrapper--chart {
  .asc-page-plot-wrapper--footer-container {
    .asc-page-plot-wrapper--footer {
      display: none;
    }
  }
}

.asc-page-plot-wrapper--chart:hover {
  .asc-page-plot-wrapper--footer {
    display: inherit;
  }
}
</style>
